







































































































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { Meter, IMeter } from '@/services/models'
import { Action, Getter } from 'vuex-class'

import { formatters } from '@/helpers/components-utils'
import DatePicker from '@/components/DatePicker.vue'

@Component({
  components: {
    DatePicker,
  },
})
export default class EditMeterModal extends Vue {

  @Action('firestore/writeMeter')
  private writeMeter!: (meter: Meter) => Promise<Meter>

  private isModalOpen: boolean = false

  private title: string = ''

  private localCopy: Meter = new Meter()

  private formatters = formatters

  private lockLastValues: boolean = false

  public async _commit(value: Meter, buttonEvent: any) {
    // Validate
    console.log('Committed!!', buttonEvent)

    // Invoke API
    await this.writeMeter(value)

    // Really push to event handler
    this.commit(value)
  }

  @Emit()
  public commit(value: Meter) {
    // emit!
  }

  // PUBLIC Interface

  public edit(data: Meter) {
    this.show()
    this.isModalOpen = true
    this.title = `Edit Meter Record: ${data.id}`
    this.localCopy = Meter.cloneFrom(data)
    this.lockLastValues = false
  }

  public create(from: Meter | undefined) {
    this.show()
    this.isModalOpen = true
    this.title = 'Create new Meter Record'
    this.localCopy = Meter.continueFrom(from)
    if (from) {
      this.lockLastValues = true
    } else {
      this.lockLastValues = false
    }
  }

  private show() {
    (this.$refs.modalRef as any).show()
  }
}
